import React, { useState } from "react";

import { Flex, Button, Modal, Box, Text, Heading } from "samba-ui";
import styled from "styled-components";

const Checkbox = styled.input`
  width: 20px;
  height: 20px;
`;

const NotifyUsersEmailApproval = ({ isOpen, onClose, onSubmit }) => {
  const [notifyUser, setNotifyUser] = useState(false);
  const [notifyFinance, setNotifyFinance] = useState(false);

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} width={800}>
      <Modal.Header borderColor="#d6d6d6 !important">
        <Heading fontSize={2} fontWeight={500} color="secondary">
          Notify Users
        </Heading>
      </Modal.Header>
      <Modal.Content minHeight={150}>
        <Text fontSize={2} fontWeight={500}>
          Select following options to send a dashboard creation email to...
        </Text>
        <Flex mt={3}>
          <Checkbox
            type="checkbox"
            checked={notifyUser}
            onChange={e => setNotifyUser(e.target.checked)}
          />
          <Text ml={1}>Notify Assigned User</Text>
        </Flex>
        <Flex mt={3}>
          <Checkbox
            type="checkbox"
            checked={notifyFinance}
            onChange={e => setNotifyFinance(e.target.checked)}
          />
          <Text ml={1}>Notify Finance</Text>
        </Flex>
      </Modal.Content>
      <Modal.Actions justifyContent="flex-end" borderColor="#d6d6d6 !important">
        <Flex>
          <Box mr={3}>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </Box>
          <Button
            variant="primary"
            onClick={() => onSubmit({ notifyUser, notifyFinance })}
          >
            Send Email
          </Button>
        </Flex>
      </Modal.Actions>
    </Modal>
  );
};

export default NotifyUsersEmailApproval;
